import { defineMessages } from 'react-intl'

export const reportingActivityMessage = defineMessages({
  idleTime: {
    defaultMessage: 'Idle Time',
    description: 'event type',
  },
})
